export const RELATIVE_API_URL = '/api';
export const PATH_TO_IMAGES = __preSettings__.resourcesPath + 'images';
export const DEFAULT_LANGUAGE = 'en';
export const BASE_PATH = __preSettings__.basePath;
export const DEVICE_DESKTOP = 'desktop';
export const DEVICE_MOBILE = 'mobile';
// Set by the entry file (desktop-index.js / mobile-index.js) based on which
// bundle is loaded. Falls back to desktop if it wasn't set for some reason.
export const CURRENT_DEVICE_TYPE = window.__CURRENT_DEVICE_TYPE__ || DEVICE_DESKTOP;
export const DICTIONARY = {};//__dictionary__;
export const LPSOLVER_URL = __preSettings__.lpSolverUrl;
